export interface ITransactionValues {
  amount?: string;
  transaction_type: 'pay' | 'tokenise' | 'pay_and_tokenise';
  name_on_card?: string;
  payment_reference?: string;
  token_reference?: string;
  metadata?: Record<string, unknown>;
}

export interface ITransactionData {
  state?: 'submitting' | 'success' | 'failure';
  request: ITransactionValues;
  response: {
    transaction_id?: string;
    receipt?: string;
    error_code?: number;
    error_message?: string;
    format?: number;
    raw?: Record<string, unknown>;
  };
  secureData?: Record<string, unknown>;
  session?: string;
}
